import React from 'react';
import { useVersionCheck } from '../hooks/useVersionCheck';

function UpdateToast() {
  const { updateAvailable, refresh } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        backgroundColor: '#1e3a5f',
        color: '#fff',
        padding: '16px 20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        maxWidth: '320px',
        animation: 'slideIn 0.3s ease-out'
      }}
    >
      <span style={{ fontSize: '20px' }}>🔄</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: '600', marginBottom: '4px' }}>
          Update Available
        </div>
        <div style={{ fontSize: '13px', opacity: 0.9 }}>
          A new version is ready. The dashboard will update automatically when safe.
        </div>
      </div>
      <button
        onClick={refresh}
        style={{
          backgroundColor: '#fff',
          color: '#1e3a5f',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontWeight: '600',
          fontSize: '13px'
        }}
      >
        Refresh
      </button>
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
}

export default UpdateToast;
